import { useState, useEffect } from 'react';

// TODO  - Optimize this hook. Move value to store and remove everything eventListeners
function useScreenWidth(): number {
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenWidth;
}

export default useScreenWidth;
